import React from 'react';

import config from 'utils/config';
import {getUrlServiceHref} from 'utils/getUrlServiceHref';

import {NavMenuItem, NavMenuDivider} from 'components/NavMenu';

function isValidCustomLink(customLink) {
	return customLink?.title?.trim() && customLink.url;
}

function getCustomLinks({
	customUserMenuLink1,
	customUserMenuLink2,
	customUserMenuLink3,
}) {
	return [
		customUserMenuLink1,
		customUserMenuLink2,
		customUserMenuLink3,
	].filter(isValidCustomLink);
}

function CustomUserMenuLinks() {
	const customLinks = getCustomLinks(config);

	if (customLinks.length === 0) return null;

	return (
		<>
			<NavMenuDivider />
			{customLinks.map(item => (
				<NavMenuItem
					as="a"
					key={item.title}
					href={getUrlServiceHref(item.url)}
				>
					{item.title}
				</NavMenuItem>
			))}
		</>
	);
}

export default CustomUserMenuLinks;
